/**
 * Removes fields from the object
 * @param fields
 * @param target
 * @param valueRule additional rule for value of the matched field. Removes field if true is returned.
 * @returns filtered object. Still the same type as the target.
 */
export function omitFields<T>(
  fields: (keyof T)[],
  target: T,
  valueRule: (value: T[keyof T]) => boolean = () => true
): T {
  const mappedFields = Object.keys(target).reduce((acc, field) => {
    if (!fields.find(item => item === field && valueRule(target[item]))) {
      return { ...acc, [field]: target[field as keyof T] };
    }
    return acc;
  }, {});

  return mappedFields as unknown as T;
}
